import React from "react";
import {
  Accordion,
  AccordionSummary,
  Typography,
  AccordionDetails,
  Box,
  Button,
  Badge,
  Checkbox,
  FormControlLabel,
} from "@material-ui/core";
import { useSelector, shallowEqual } from "react-redux";
import { useFormikContext } from "formik";
import { DebouncedTextField } from "./DebouncedTextField";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";

export const Dial = (props) => {
  const selectStyles = {
    fontSize: '12px',
    height: '24px',
    padding: '2px 12px 2px 5px',
    border: '1px solid rgba(0, 0, 0, 0.23)',
    backgroundColor: 'transparent',
    width: '100%',
  };

  const siteId = useSelector((state) => state.scopes.site_id);
  const { classes } = props;
  const { values, setFieldValue } = useFormikContext();
  const handleNext = () => {
    props.setActiveStep(5);
  };
  const {
    dial_color: dial_color_list,
    hour_marker_color: hour_marker_color_list,
    hour_marker_type: hour_marker_type_list,
    hour_marker: hour_marker_list,
    dial_finish: dial_finish_list,
    hands_finish: hands_finish_list,
    hands_color: hands_color_list,
    second_hand: second_hand_list,
    track_type: track_type_list,
    hands_material: hands_material_list,
    flange_indication: flange_indication_list,
    // date_type: date_type_list,
    date_location: date_location_list,
    date_indicator: date_indicator_list,
  } = useSelector((state) => state.watches.watchLists, shallowEqual);

  return (
    <Accordion expanded={true} style={{ width: "100%" }}>
      <AccordionSummary
        style={{ cursor: "default" }}
        aria-controls="panel1a-content"
        id="panel1a-header"
        className={classes.expanded}
        tabIndex={-1}
      >
        <Typography>
          <Badge badgeContent={props.requiredDialBadge} color="secondary">
            Dial Description
          </Badge>
        </Typography>
      </AccordionSummary>
      <AccordionDetails className={classes.grid} style={{ display: "grid" }}>
        <Box display="flex" flexWrap="wrap" flexDirection="column" alignItems="left">

          {/* ROW 1: Main Dial Color | Dial Finish | Dial Notes */}
          <Box display="flex" alignItems="center" mx={1} mb={1} style={{ gap: 16, marginLeft: 8 }}>
            <div style={{ display: "flex", flexDirection: "column", gap: 1, width: 150 }}>
              <label style={{ fontSize: 11 }}>Main Dial Color:</label>
              <select
                disabled={siteId !== 0}
                value={values.dial_color_id || ""}
                onChange={(e) => setFieldValue("dial_color_id", e.target.value ? Number(e.target.value) : null)}
                className={siteId !== 0 ? `${classes.gridTwoBlack} custom-select` : values.dial_color_id ? `${classes.gridTwoBlue} custom-select` : `${classes.gridTwo} custom-select`}
                style={selectStyles}
              >
                <option value=""></option>
                {(dial_color_list || []).sort((a, b) => (a.dial_color || "").localeCompare(b.dial_color || "")).map((c) => (
                  <option key={c.dial_color_id} value={c.dial_color_id}>{c.dial_color}</option>
                ))}
              </select>
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 1, width: 120 }}>
              <label style={{ fontSize: 11 }}>Dial Finish:</label>
              <select
                disabled={siteId !== 0}
                value={values.dial_finish_id || ""}
                onChange={(e) => setFieldValue("dial_finish_id", e.target.value ? Number(e.target.value) : null)}
                className={siteId !== 0 ? `${classes.gridTwoBlack} custom-select` : values.dial_finish_id ? `${classes.gridTwoBlue} custom-select` : `${classes.gridTwo} custom-select`}
                style={selectStyles}
              >
                <option value=""></option>
                {(dial_finish_list || []).sort((a, b) => (a.dial_finish || "").localeCompare(b.dial_finish || "")).map((f) => (
                  <option key={f.dial_finish_id} value={f.dial_finish_id}>{f.dial_finish}</option>
                ))}
              </select>
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 1, width: 818 }}>
              <label style={{ fontSize: 11 }}>Dial Notes:</label>
              <DebouncedTextField
                disabled={siteId !== 0}
                className={siteId !== 0 ? classes.gridTwoBlack : values.main_dial_notes ? classes.gridTwoBlue : classes.gridTwo}
                name="main_dial_notes"
                style={{ width: "100%" }}
                multiline
              />
            </div>
          </Box>

          {/* ROW 2: Subdial Color | Subdial Notes */}
          <Box display="flex" alignItems="center" mx={1} mb={1} style={{ gap: 16 }}>
            <div style={{ display: "flex", flexDirection: "column", gap: 1, width: 140 }}>
              <label style={{ fontSize: 11 }}>Subdial Color:</label>
              <select
                disabled={siteId !== 0}
                value={values.subdial_color_id || ""}
                onChange={(e) => setFieldValue("subdial_color_id", e.target.value ? Number(e.target.value) : null)}
                className={siteId !== 0 ? `${classes.gridTwoBlack} custom-select` : values.subdial_color_id ? `${classes.gridTwoBlue} custom-select` : `${classes.gridTwo} custom-select`}
                style={selectStyles}
              >
                <option value=""></option>
                {(dial_color_list || []).sort((a, b) => (a.dial_color || "").localeCompare(b.dial_color || "")).map((c) => (
                  <option key={c.dial_color_id} value={c.dial_color_id}>{c.dial_color}</option>
                ))}
              </select>
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 1, width: 400 }}>
              <label style={{ fontSize: 11 }}>Subdial Notes:</label>
              <DebouncedTextField
                disabled={siteId !== 0}
                className={siteId !== 0 ? classes.gridTwoBlack : values.subdial_notes ? classes.gridTwoBlue : classes.gridTwo}
                name="subdial_notes"
                style={{ width: "100%" }}
                multiline
              />
            </div>

            <div style={{ display: "flex", flexDirection: "column", gap: 1, width: 120 }}>
              <label style={{ fontSize: 11 }}>Lume:</label>
              <select
                disabled={siteId !== 0}
                value={values.luminescence_id || ""}
                onChange={(e) => setFieldValue("luminescence_id", e.target.value ? Number(e.target.value) : null)}
                className={siteId !== 0 ? `${classes.gridTwoBlack} custom-select` : values.luminescence_id ? `${classes.gridTwoBlue} custom-select` : `${classes.gridTwo} custom-select`}
                style={selectStyles}
              >
                <option value=""></option>
                {luminescence_list.map((l) => (
                  <option key={l.luminescence_id} value={l.luminescence_id}>{l.luminescence}</option>
                ))}
              </select>
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 1, width: 412 }}>
              <label style={{ fontSize: 11 }}>Lume Notes:</label>
              <DebouncedTextField
                disabled={siteId !== 0}
                className={siteId !== 0 ? classes.gridTwoBlack : values.luminescence_notes ? classes.gridTwoBlue : classes.gridTwo}
                name="luminescence_notes"
                style={{ width: "100%" }}
                multiline
              />
            </div>
          </Box>

          {/* ROW 3: Lum | Lum Notes */}
          <Box display="flex" alignItems="center" mx={1} mb={1} style={{ gap: 16 }}>
          </Box>

          {/* ROW 4: Hour Marker Type | Hour Marker | Hour Marker Material | Hour Marker Finish | Hour Marker Color | Hour Marker Notes */}
          <Box display="flex" alignItems="center" mx={1} mb={1} style={{ gap: 16 }}>
            <div style={{ display: "flex", flexDirection: "column", gap: 1, width: 100 }}>
              <label style={{ fontSize: 11 }}>Hour Marker Type:</label>
              <select
                disabled={siteId !== 0}
                value={values.hour_marker_type_id || ""}
                onChange={(e) => setFieldValue("hour_marker_type_id", e.target.value ? Number(e.target.value) : null)}
                className={siteId !== 0 ? `${classes.gridTwoBlack} custom-select` : values.hour_marker_type_id ? `${classes.gridTwoBlue} custom-select` : `${classes.gridTwo} custom-select`}
                style={selectStyles}
              >
                <option value=""></option>
                {(hour_marker_type_list || []).sort((a, b) => (a.hour_marker_type || "").localeCompare(b.hour_marker_type || "")).map((t) => (
                  <option key={t.hour_marker_type_id} value={t.hour_marker_type_id}>{t.hour_marker_type}</option>
                ))}
              </select>
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 1, width: 180 }}>
              <label style={{ fontSize: 11 }}>Hour Marker:</label>
              <select
                disabled={siteId !== 0}
                value={values.hour_marker_id || ""}
                onChange={(e) => setFieldValue("hour_marker_id", e.target.value ? Number(e.target.value) : null)}
                className={siteId !== 0 ? `${classes.gridTwoBlack} custom-select` : values.hour_marker_id ? `${classes.gridTwoBlue} custom-select` : `${classes.gridTwo} custom-select`}
                style={selectStyles}
              >
                <option value=""></option>
                {(hour_marker_list || []).sort((a, b) => (a.hour_marker || "").localeCompare(b.hour_marker || "")).map((m) => (
                  <option key={m.hour_marker_id} value={m.hour_marker_id}>{m.hour_marker}</option>
                ))}
              </select>
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 1, width: 130 }}>
              <label style={{ fontSize: 11 }}>Hour Marker Material:</label>
              <select
                disabled={siteId !== 0}
                value={values.hour_marker_material_id || ""}
                onChange={(e) => setFieldValue("hour_marker_material_id", e.target.value ? Number(e.target.value) : null)}
                className={siteId !== 0 ? `${classes.gridTwoBlack} custom-select` : values.hour_marker_material_id ? `${classes.gridTwoBlue} custom-select` : `${classes.gridTwo} custom-select`}
                style={selectStyles}
              >
                <option value=""></option>
                {(hands_material_list || []).sort((a, b) => (a.hands_material || "").localeCompare(b.hands_material || "")).map((m) => (
                  <option key={m.hands_material_id} value={m.hands_material_id}>{m.hands_material}</option>
                ))}
              </select>
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 1, width: 130 }}>
              <label style={{ fontSize: 11 }}>Hour Marker Finish:</label>
              <select
                disabled={siteId !== 0}
                value={values.hour_marker_finish_id || ""}
                onChange={(e) => setFieldValue("hour_marker_finish_id", e.target.value ? Number(e.target.value) : null)}
                className={siteId !== 0 ? `${classes.gridTwoBlack} custom-select` : values.hour_marker_finish_id ? `${classes.gridTwoBlue} custom-select` : `${classes.gridTwo} custom-select`}
                style={selectStyles}
              >
                <option value=""></option>
                {(hands_finish_list || []).sort((a, b) => (a.hands_finish || "").localeCompare(b.hands_finish || "")).map((f) => (
                  <option key={f.hands_finish_id} value={f.hands_finish_id}>{f.hands_finish}</option>
                ))}
              </select>
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 1, width: 140 }}>
              <label style={{ fontSize: 11 }}>Hour Marker Color:</label>
              <select
                disabled={siteId !== 0}
                value={values.hour_marker_color_id || ""}
                onChange={(e) => setFieldValue("hour_marker_color_id", e.target.value ? Number(e.target.value) : null)}
                className={siteId !== 0 ? `${classes.gridTwoBlack} custom-select` : values.hour_marker_color_id ? `${classes.gridTwoBlue} custom-select` : `${classes.gridTwo} custom-select`}
                style={selectStyles}
              >
                <option value=""></option>
                {(hour_marker_color_list || []).sort((a, b) => (a.hour_marker_color || "").localeCompare(b.hour_marker_color || "")).map((c) => (
                  <option key={c.hour_marker_color_id} value={c.hour_marker_color_id}>{c.hour_marker_color}</option>
                ))}
              </select>
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 1, width: 361 }}>
              <label style={{ fontSize: 11 }}>Hour Marker Notes:</label>
              <DebouncedTextField
                disabled={siteId !== 0}
                className={siteId !== 0 ? classes.gridTwoBlack : values.hour_marker_notes ? classes.gridTwoBlue : classes.gridTwo}
                name="hour_marker_notes"
                style={{ width: "100%" }}
                multiline
              />
            </div>
          </Box>

          {/* ROW 5: Hour Marker Lum | Hr. Marker Lum Notes */}
          <Box display="flex" alignItems="center" mx={1} mb={1} style={{ gap: 16 }}>
            <Box style={{ width: 100 }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={!!values.hour_marker_luminescence}
                    disabled={siteId !== 0}
                    onChange={(e) => setFieldValue("hour_marker_luminescence", e.target.checked)}
                    style={{ padding: 0 }}
                  />
                }
                label={<span style={{ fontSize: 11 }}>Hour Marker Lume:</span>}
                labelPlacement="top"
                style={{ margin: 0, gap: 0 }}
              />
            </Box>
            <div style={{ display: "flex", flexDirection: "column", gap: 1, width: 1005 }}>
              <label style={{ fontSize: 11 }}>Hr. Marker Lume Notes:</label>
              <DebouncedTextField
                disabled={siteId !== 0}
                className={siteId !== 0 ? classes.gridTwoBlack : values.hour_marker_luminescence_notes ? classes.gridTwoBlue : classes.gridTwo}
                name="hour_marker_luminescence_notes"
                style={{ width: "100%" }}
                multiline
              />
            </div>
          </Box>

          {/* ROW 6: Track | Track Notes */}
          <Box display="flex" alignItems="center" mx={1} mb={1} style={{ gap: 16 }}>
            <div style={{ display: "flex", flexDirection: "column", gap: 1, width: 230 }}>
              <label style={{ fontSize: 11 }}>Track:</label>
              <select
                disabled={siteId !== 0}
                value={values.track_type_id || ""}
                onChange={(e) => setFieldValue("track_type_id", e.target.value ? Number(e.target.value) : null)}
                className={siteId !== 0 ? `${classes.gridTwoBlack} custom-select` : values.track_type_id ? `${classes.gridTwoBlue} custom-select` : `${classes.gridTwo} custom-select`}
                style={selectStyles}
              >
                <option value=""></option>
                {(track_type_list || []).sort((a, b) => (a.track_type || "").localeCompare(b.track_type || "")).map((t) => (
                  <option key={t.track_type_id} value={t.track_type_id}>{t.track_type}</option>
                ))}
              </select>
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 1, width: 875 }}>
              <label style={{ fontSize: 11 }}>Track Notes:</label>
              <DebouncedTextField
                disabled={siteId !== 0}
                className={siteId !== 0 ? classes.gridTwoBlack : values.track_notes ? classes.gridTwoBlue : classes.gridTwo}
                name="track_notes"
                style={{ width: "100%" }}
                multiline
              />
            </div>
          </Box>

          {/* ROW 7: Hands Material | Hand Color | Hand Finish | Hand Notes */}
          <Box display="flex" alignItems="center" mx={1} mb={1} style={{ gap: 16 }}>
            <div style={{ display: "flex", flexDirection: "column", gap: 1, width: 120 }}>
              <label style={{ fontSize: 11 }}>Hands Material:</label>
              <select
                disabled={siteId !== 0}
                value={values.hands_material_id || ""}
                onChange={(e) => setFieldValue("hands_material_id", e.target.value ? Number(e.target.value) : null)}
                className={siteId !== 0 ? `${classes.gridTwoBlack} custom-select` : values.hands_material_id ? `${classes.gridTwoBlue} custom-select` : `${classes.gridTwo} custom-select`}
                style={selectStyles}
              >
                <option value=""></option>
                {(hands_material_list || []).sort((a, b) => (a.hands_material || "").localeCompare(b.hands_material || "")).map((m) => (
                  <option key={m.hands_material_id} value={m.hands_material_id}>{m.hands_material}</option>
                ))}
              </select>
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 1, width: 120 }}>
              <label style={{ fontSize: 11 }}>Hand Color:</label>
              <select
                disabled={siteId !== 0}
                value={values.hands_color_id || ""}
                onChange={(e) => setFieldValue("hands_color_id", e.target.value ? Number(e.target.value) : null)}
                className={siteId !== 0 ? `${classes.gridTwoBlack} custom-select` : values.hands_color_id ? `${classes.gridTwoBlue} custom-select` : `${classes.gridTwo} custom-select`}
                style={selectStyles}
              >
                <option value=""></option>
                {(hands_color_list || []).sort((a, b) => (a.hands_color || "").localeCompare(b.hands_color || "")).map((c) => (
                  <option key={c.hands_color_id} value={c.hands_color_id}>{c.hands_color}</option>
                ))}
              </select>
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 1, width: 130 }}>
              <label style={{ fontSize: 11 }}>Hand Finish:</label>
              <select
                disabled={siteId !== 0}
                value={values.hands_finish_id || ""}
                onChange={(e) => setFieldValue("hands_finish_id", e.target.value ? Number(e.target.value) : null)}
                className={siteId !== 0 ? `${classes.gridTwoBlack} custom-select` : values.hands_finish_id ? `${classes.gridTwoBlue} custom-select` : `${classes.gridTwo} custom-select`}
                style={selectStyles}
              >
                <option value=""></option>
                {(hands_finish_list || []).sort((a, b) => (a.hands_finish || "").localeCompare(b.hands_finish || "")).map((f) => (
                  <option key={f.hands_finish_id} value={f.hands_finish_id}>{f.hands_finish}</option>
                ))}
              </select>
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 1, width: 703 }}>
              <label style={{ fontSize: 11 }}>Hand Notes:</label>
              <DebouncedTextField
                disabled={siteId !== 0}
                className={siteId !== 0 ? classes.gridTwoBlack : values.hands_notes ? classes.gridTwoBlue : classes.gridTwo}
                name="hands_notes"
                style={{ width: "100%" }}
                multiline
              />
            </div>
          </Box>

          {/* ROW 8: Hand Lum | Hand Lum Notes */}
          <Box display="flex" alignItems="center" mx={1} mb={1} style={{ gap: 16 }}>
            <Box style={{ width: 65 }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={!!values.hands_luminescence}
                    disabled={siteId !== 0}
                    onChange={(e) => setFieldValue("hands_luminescence", e.target.checked)}
                    style={{ padding: 0 }}
                  />
                }
                label={<span style={{ fontSize: 11 }}>Hand Lume:</span>}
                labelPlacement="top"
                style={{ margin: 0, gap: 0 }}
              />
            </Box>
            <div style={{ display: "flex", flexDirection: "column", gap: 1, width: 1040
             }}>
              <label style={{ fontSize: 11 }}>Hand Lume Notes:</label>
              <DebouncedTextField
                disabled={siteId !== 0}
                className={siteId !== 0 ? classes.gridTwoBlack : values.hands_luminescence_notes ? classes.gridTwoBlue : classes.gridTwo}
                name="hands_luminescence_notes"
                style={{ width: "100%" }}
                multiline
              />
            </div>
          </Box>

          {/* ROW 9: Second Hand | Second Hand Mat. | Second Hand Lum | Second Hand Notes */}
          <Box display="flex" alignItems="center" mx={1} mb={1} style={{ gap: 16 }}>
            <div style={{ display: "flex", flexDirection: "column", gap: 1, width: 145 }}>
              <label style={{ fontSize: 11 }}>Second Hand:</label>
              <select
                disabled={siteId !== 0}
                value={values.second_hand_id || ""}
                onChange={(e) => setFieldValue("second_hand_id", e.target.value ? Number(e.target.value) : null)}
                className={siteId !== 0 ? `${classes.gridTwoBlack} custom-select` : values.second_hand_id ? `${classes.gridTwoBlue} custom-select` : `${classes.gridTwo} custom-select`}
                style={selectStyles}
              >
                <option value=""></option>
                {(second_hand_list || []).sort((a, b) => (a.second_hand || "").localeCompare(b.second_hand || "")).map((s) => (
                  <option key={s.second_hand_id} value={s.second_hand_id}>{s.second_hand}</option>
                ))}
              </select>
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 1, width: 100 }}>
              <label style={{ fontSize: 11 }}>Second Hand Color:</label>
              {/* Shared-pool field: stores item.second_hand_color_id but the
                  options come from the Hand Color pool (item_hands_color). */}
              <select
                disabled={siteId !== 0}
                value={values.second_hand_color_id || ""}
                onChange={(e) => setFieldValue("second_hand_color_id", e.target.value ? Number(e.target.value) : null)}
                className={siteId !== 0 ? `${classes.gridTwoBlack} custom-select` : values.second_hand_color_id ? `${classes.gridTwoBlue} custom-select` : `${classes.gridTwo} custom-select`}
                style={selectStyles}
              >
                <option value=""></option>
                {(hands_color_list || []).sort((a, b) => (a.hands_color || "").localeCompare(b.hands_color || "")).map((c) => (
                  <option key={c.hands_color_id} value={c.hands_color_id}>{c.hands_color}</option>
                ))}
              </select>
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 1, width: 100 }}>
              <label style={{ fontSize: 11 }}>Second Hand Mat.:</label>
              <select
                disabled={siteId !== 0}
                value={values.second_hand_material_id || ""}
                onChange={(e) => setFieldValue("second_hand_material_id", e.target.value ? Number(e.target.value) : null)}
                className={siteId !== 0 ? `${classes.gridTwoBlack} custom-select` : values.second_hand_material_id ? `${classes.gridTwoBlue} custom-select` : `${classes.gridTwo} custom-select`}
                style={selectStyles}
              >
                <option value=""></option>
                {(hands_material_list || []).sort((a, b) => (a.hands_material || "").localeCompare(b.hands_material || "")).map((m) => (
                  <option key={m.hands_material_id} value={m.hands_material_id}>{m.hands_material}</option>
                ))}
              </select>
            </div>
            <Box style={{ width: 110 }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={!!values.second_hand_luminescence}
                    disabled={siteId !== 0}
                    onChange={(e) => setFieldValue("second_hand_luminescence", e.target.checked)}
                    style={{ padding: 0 }}
                  />
                }
                label={<span style={{ fontSize: 11 }}>Second Hand Lume:</span>}
                labelPlacement="top"
                style={{ margin: 0, gap: 0 }}
              />
            </Box>
            <div style={{ display: "flex", flexDirection: "column", gap: 1, width: 603 }}>
              <label style={{ fontSize: 11 }}>Second Hand Notes:</label>
              <DebouncedTextField
                disabled={siteId !== 0}
                className={siteId !== 0 ? classes.gridTwoBlack : values.second_hand_notes ? classes.gridTwoBlue : classes.gridTwo}
                name="second_hand_notes"
                style={{ width: "100%" }}
                multiline
              />
            </div>
          </Box>

          {/* ROW 10: Dial Flange Color | Flange Indication */}
          <Box display="flex" alignItems="center" mx={1} mb={1} style={{ gap: 16 }}>
            <div style={{ display: "flex", flexDirection: "column", gap: 1, width: 180 }}>
              <label style={{ fontSize: 11 }}>Dial Flange Color:</label>
              <select
                disabled={siteId !== 0}
                value={values.dial_flange_color_id || ""}
                onChange={(e) => setFieldValue("dial_flange_color_id", e.target.value ? Number(e.target.value) : null)}
                className={siteId !== 0 ? `${classes.gridTwoBlack} custom-select` : values.dial_flange_color_id ? `${classes.gridTwoBlue} custom-select` : `${classes.gridTwo} custom-select`}
                style={selectStyles}
              >
                <option value=""></option>
                {(dial_color_list || []).sort((a, b) => (a.dial_color || "").localeCompare(b.dial_color || "")).map((c) => (
                  <option key={c.dial_color_id} value={c.dial_color_id}>{c.dial_color}</option>
                ))}
              </select>
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 1, width: 110 }}>
              <label style={{ fontSize: 11 }}>Flange Indication:</label>
              <select
                disabled={siteId !== 0}
                value={values.flange_indication_id || ""}
                onChange={(e) => setFieldValue("flange_indication_id", e.target.value ? Number(e.target.value) : null)}
                className={siteId !== 0 ? `${classes.gridTwoBlack} custom-select` : values.flange_indication_id ? `${classes.gridTwoBlue} custom-select` : `${classes.gridTwo} custom-select`}
                style={selectStyles}
              >
                <option value=""></option>
                {(flange_indication_list || []).sort((a, b) => (a.flange_indication || "").localeCompare(b.flange_indication || "")).map((f) => (
                  <option key={f.flange_indication_id} value={f.flange_indication_id}>{f.flange_indication}</option>
                ))}
              </select>
            </div>
          </Box>

          {/* ROW 11: Date Displayed | Date Indicator | Date Location | Date Notes | Next */}
          <Box display="flex" alignItems="center" mx={1} mb={1} style={{ gap: 16 }}>
            <Box style={{ width: 90 }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={!!values.date_display}
                    disabled={siteId !== 0}
                    onChange={(e) => setFieldValue("date_display", e.target.checked)}
                    style={{ padding: 0 }}
                  />
                }
                label={<span style={{ fontSize: 11 }}>Date Displayed:</span>}
                labelPlacement="top"
                style={{ margin: 0, gap: 0 }}
              />
            </Box>
            <div style={{ display: "flex", flexDirection: "column", gap: 1, width: 120 }}>
              <label style={{ fontSize: 11 }}>Date Indicator:</label>
              <select
                disabled={siteId !== 0}
                value={values.date_indicator_id || ""}
                onChange={(e) => setFieldValue("date_indicator_id", e.target.value ? Number(e.target.value) : null)}
                className={siteId !== 0 ? `${classes.gridTwoBlack} custom-select` : values.date_indicator_id ? `${classes.gridTwoBlue} custom-select` : `${classes.gridTwo} custom-select`}
                style={selectStyles}
              >
                <option value=""></option>
                {(date_indicator_list || []).sort((a, b) => (a.date_indicator || "").localeCompare(b.date_indicator || "")).map((d) => (
                  <option key={d.date_indicator_id} value={d.date_indicator_id}>{d.date_indicator}</option>
                ))}
              </select>
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 1, width: 120 }}>
              <label style={{ fontSize: 11 }}>Date Location:</label>
              <select
                disabled={siteId !== 0}
                value={values.date_location_id || ""}
                onChange={(e) => setFieldValue("date_location_id", e.target.value ? Number(e.target.value) : null)}
                className={siteId !== 0 ? `${classes.gridTwoBlack} custom-select` : values.date_location_id ? `${classes.gridTwoBlue} custom-select` : `${classes.gridTwo} custom-select`}
                style={selectStyles}
              >
                <option value=""></option>
                {(date_location_list || []).sort((a, b) => (a.date_location || "").localeCompare(b.date_location || "")).map((d) => (
                  <option key={d.date_location_id} value={d.date_location_id}>{d.date_location}</option>
                ))}
              </select>
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 1, width: 745 }}>
              <label style={{ fontSize: 11 }}>Date Notes:</label>
              <DebouncedTextField
                disabled={siteId !== 0}
                className={siteId !== 0 ? classes.gridTwoBlack : values.date_notes ? classes.gridTwoBlue : classes.gridTwo}
                name="date_notes"
                style={{ width: "100%" }}
                multiline
              />
            </div>
            
            {/**
             * 
            <Button
              color="primary"
              onClick={handleNext}
              className={classes.button}
              endIcon={<ArrowDownwardIcon />}
            >
              Next
            </Button>
             * 
             */}

          </Box>

        </Box>
      </AccordionDetails>
    </Accordion>
  );
};

const luminescence_list = [
  { luminescence_id: 1, luminescence: "Extremely visible" },
  { luminescence_id: 2, luminescence: "Standard visibility" },
  { luminescence_id: 3, luminescence: "Basically visible" },
  { luminescence_id: 4, luminescence: "Weak visibility" },
];
